export default "__VITE_ASSET__DD1wA6nk__"